module.exports = __webpack_public_path__ + "static/social-media-poster-859a626ee1046541e60906c150dab830.jpg";